import {
	PHARMACY_ALL_TABLE_LIST_DATA_REQUEST,
	PHARMACY_ALL_TABLE_LIST_DATA_SUCCESS,
	PHARMACY_ALL_TABLE_LIST_DATA_FAILURE
} from '../../../constants';


const initialState = {
	data: null,
	loading: false,
	error: null,
};

const pharmacyTableDataReducer = (state = initialState, action) => {
	switch (action.type) {
		case PHARMACY_ALL_TABLE_LIST_DATA_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			};
		case PHARMACY_ALL_TABLE_LIST_DATA_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null,
			};
		case PHARMACY_ALL_TABLE_LIST_DATA_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				data: null,
			};
		default:
			return state;
	}
};

export default pharmacyTableDataReducer;
